import { application } from './application';

import CartRendererController from './cart_renderer_controller';
application.register('cart-renderer', CartRendererController);

import PriceToolRendererController from './price_tool_renderer_controller';
application.register('price-tool-renderer', PriceToolRendererController);

import ProjectsRendererController from './projects_renderer_controller';
application.register('projects-renderer', ProjectsRendererController);

import WosRendererController from './wos_renderer_controller';
application.register('wos-renderer', WosRendererController);
